import { JDSHeaderMobileProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSHeaderMobileProps>
  ): React.FC<JDSHeaderMobileProps> =>
  (props: JDSHeaderMobileProps) => {
    return <Component {...props} />;
  };
